export const CORS_PROXY = 'https://api.allorigins.win/get?url='
/** Resposta XML direta (menos parsing; útil quando /get falha). */
export const CORS_PROXY_RAW = 'https://api.allorigins.win/raw?url='
export const REFRESH_MS = 2 * 60 * 60 * 1000
export const MAX_AGE_DAYS = 30
/** Timeout por feed; feeds lentos ou proxy ocupado precisam de margem. */
export const FETCH_TIMEOUT_MS = 18_000
/** Itens máximos lidos por feed antes de filtrar por idade. */
export const MAX_ITEMS_PER_FEED = 50
/**
 * Teto de itens persistidos no cache local do feed (app-layer, localStorage).
 * Evita crescimento ilimitado em sessões longas; merge remoto aplica o mesmo cap.
 */
export const FEED_NEWS_CACHE_MAX_ITEMS = 150
/** Requisições RSS em paralelo (muitas conexões + falhas SSL no proxy geram console enorme no mobile). */
export const RSS_FETCH_BATCH_SIZE = 2
/** Pausa entre lotes para reduzir 429 / falhas em muitos feeds. */
export const RSS_BATCH_DELAY_MS = 900

export const CUSTOM_COLOR_PALETTE = [
  '#0F766E',
  '#B45309',
  '#7C3AED',
  '#0369A1',
  '#BE185D',
  '#065F46',
  '#92400E',
  '#1D4ED8',
]

/** Fallback quando os feeds RSS falham ou retornam vazio. */
export const MOCK_NEWS: Array<{
  id: string
  title: string
  summary: string
  link: string
  sourceId: string
  sourceLabel: string
  sourceShort: string
  sourceColor: string
}> = [
  {
    id: 'mock-sbp-1',
    title: 'SBP atualiza protocolo de vacinação para crianças em 2025',
    sourceLabel: 'Soc. Bras. de Pediatria',
    sourceShort: 'SBP',
    sourceColor: '#1565C0',
    sourceId: 'sbp-br',
    summary: 'Novas diretrizes incorporam vacinas contra meningite B e dengue no calendário pediátrico regular.',
    link: 'https://www.sbp.com.br/noticias/',
  },
  {
    id: 'mock-ms-1',
    title: 'Ministério da Saúde lança campanha de prevenção ao dengue',
    sourceLabel: 'Ministério da Saúde',
    sourceShort: 'MS',
    sourceColor: '#006847',
    sourceId: 'ms-br',
    summary: 'Campanha nacional orienta população sobre eliminação de focos do mosquito Aedes aegypti.',
    link: 'https://www.gov.br/saude/pt-br/assuntos/noticias',
  },
  {
    id: 'mock-fio-1',
    title: 'Fiocruz identifica nova variante influenza circulante no Brasil',
    sourceLabel: 'Fiocruz',
    sourceShort: 'FIO',
    sourceColor: '#6A0DAD',
    sourceId: 'fiocruz-br',
    summary: 'Monitoramento epidemiológico aponta circulação de H3N2 com aumento nos casos em crianças menores de 5 anos.',
    link: 'https://portal.fiocruz.br/noticias',
  },
  {
    id: 'mock-cfm-1',
    title: 'CFM publica resolução sobre telemedicina e prescrição digital',
    sourceLabel: 'CFM',
    sourceShort: 'CFM',
    sourceColor: '#B71C1C',
    sourceId: 'cfm-br',
    summary: 'Novas regras regulamentam atendimento remoto e assinatura eletrônica de receitas e laudos médicos.',
    link: 'https://portal.cfm.org.br/noticias/',
  },
]
